<template>
<div>
    <Breadcrumbs main="Admin" title="Changemakers" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">

                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <div class="d-flex flex-column flex-xl-row " style="gap: 10px;">
                                    <b-input-group class="datatable-btn">
                                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </div>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="items" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(created)="row">
                                        {{row.value.split('T')[0]}}
                                    </template>

                                    <template #cell(name)="row">
                                        <div style="min-width: 200px; max-width: 280px;">
                                            <router-link :to="`/admin/changemaker-view/${row.item.id}`">
                                                <h7>{{ row.item.name }}</h7>
                                            </router-link>
                                        </div>
                                    </template>

                                    <template #cell(interest_in_joining)="row">
                                        <div style="max-width: 280px;">
                                            <div class="d-flex flex-wrap" style="gap: 4px;">
                                                <div v-for="interest in row.item.interest_in_joining" :key="interest">
                                                    <b-badge variant="info"><span style="text-transform: capitalize;">{{ interest }}</span></b-badge>
                                                </div>
                                            </div>
                                        </div>
                                    </template>

                                    <template #cell(contact)="row">
                                        <div style="max-width: 320px;">
                                            <div class="d-flex flex-column" style="gap: 4px;">
                                                <div v-for="contact in row.item.contact" :key="contact">
                                                    <div style="display: flex; flex-direction: row; gap: 2px;">
                                                        <span>{{ contact.email }}</span>
                                                        <span style="margin-left: 4px;">{{ contact.phone }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>

                                    <template #cell(category)="row">
                                        <div style="min-width: 80px;">
                                            <div style="text-transform: uppercase;">{{ row.item?.category }}</div>
                                        </div>
                                    </template>

                                    <template #cell(verification_status)="row">
                                        <div style="min-width: 60px;">
                                            <div v-if="row.item.verification_status == 'verified'" @click="updateToggle(row.item.id)" style="cursor: pointer;">
                                                <b-badge variant="success">Verified</b-badge>
                                            </div>
                                            <div v-else @click="updateToggle(row.item.id)" style="cursor: pointer;">
                                                <b-badge variant="danger">Pending</b-badge>
                                            </div>
                                        </div>
                                    </template>

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <router-link :to="`/admin/changemaker-view/${data.item.id}`">
                                                <feather type="eye" size="22px" style="cursor: pointer;" v-b-tooltip.hover title="View"></feather>
                                            </router-link>
                                            <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteChangemaker(data.item.id)" title="Delete"></feather>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- View Modal -->
    <b-modal id="modal-view-center" size="xl" centered hide-footer title="View Changemaker">
        <h6>USER INFO</h6>
        <div class="row">
            <div class="col-sm-4">
                <div>
                    <h7>Name</h7>
                    <h6 style="margin-top: 2px;">{{ changemaker_view?.user?.first_name }} {{ changemaker_view?.user?.last_name }}</h6>
                </div>
            </div>
            <div class="col-sm-4">
                <div>
                    <h7>Personal ID</h7>
                    <h6 style="margin-top: 2px;">{{ changemaker_view?.personal_id_no }}</h6>
                </div>
            </div>
            <div class="col-sm-4">
                <div>
                    <h7>Email</h7>
                    <h6 style="margin-top: 2px;">{{ changemaker_view?.user?.email }}</h6>
                </div>
            </div>
        </div>
        <div class="row mt-3">  
            <div class="col-sm-4">
                <div>
                    <h7>Phone No.</h7>
                    <h6 style="margin-top: 2px;">{{ changemaker_view?.phone_number }}</h6>
                </div>
            </div>
            <div class="col-sm-4">
                <div>
                    <h7>Category</h7>
                    <h6 style="margin-top: 2px; text-transform: uppercase;">{{ changemaker_view?.category }}</h6>
                </div>
            </div>
            <div class="col-sm-4">
                <div>
                    <h7>Status</h7>
                    <div v-if="changemaker_view?.verification_status == 'verified'" @click="updateToggle(changemaker_view?.id)" style="cursor: pointer;">
                        <b-badge variant="success">Verified</b-badge>
                    </div>
                    <div v-else @click="updateToggle(changemaker_view?.id)" style="cursor: pointer;">
                        <b-badge variant="danger">Pending</b-badge>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-sm-12">
                <div>
                    <h7>Bio</h7>
                    <div style="margin-top: 2px;" v-html="changemaker_view?.bio"></div>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-sm-12">
                <div>
                    <h7>Social Change Interests</h7>
                    <div style="display: flex; flex-wrap: wrap; gap: 4px;">
                        <div v-for="interest in changemaker_view?.social_change_interests">
                            <b-badge variant="info">{{ interest }}</b-badge>
                        </div>
                    </div>
                </div>
            </div>
        </div>
         <!-- <h6 class="mt-4" style="text-transform: uppercase;">IMAGES</h6>
        <div class="row mt-2" v-if="changemaker_view?.profile_pic">
            <div class="col-sm-12">
                <div style="display: flex; flex-direction: column;">
                    <h7>Profile Pic</h7>
                    <img style="max-height: 100px; max-width: fit-content;" :src="host + changemaker_view?.profile_pic" alt="">
                </div>
            </div>
        </div>
        <div class="row mt-2" v-if="changemaker_view?.banner">
            <div class="col-sm-12">
                <div style="display: flex; flex-direction: column;">
                    <h7>Banner</h7>
                    <img style="max-height: 200px; max-width: fit-content;" :src="host + changemaker_view?.banner" alt="">
                </div>
            </div>
        </div> -->
        <h6 style="text-transform: uppercase; margin-top: 30px;">{{ changemaker_view?.category }} Info</h6>
        <div v-if="changemaker_view?.category == 'ngo'">
            <div class="row">
                <div class="col-sm-4">
                    <div>
                        <h7>Name</h7>
                        <h6 style="margin-top: 2px;">{{ changemaker_view?.ngos?.name }}</h6>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div>
                        <h7>Contact Person</h7>
                        <h6 style="margin-top: 2px;">{{ changemaker_view?.ngos?.contact_person_name }}</h6>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div>
                        <h7>Email</h7>
                        <h6 style="margin-top: 2px;">{{ changemaker_view?.ngos?.email }}</h6>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-sm-4">
                    <div>
                        <h7>Phone Number</h7>
                        <h6 style="margin-top: 2px;">{{ changemaker_view?.ngos?.phone_number }}</h6>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div>
                        <h7>Number of Employees</h7>
                        <h6 style="margin-top: 2px;">{{ changemaker_view?.ngos?.number_of_employee }}</h6>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div>
                        <h7>Registered</h7>
                        <div style="margin-top: 2px;">
                            <b-badge v-if="changemaker_view?.ngos?.registration == true" variant="success">Yes</b-badge>
                            <b-badge v-else variant="danger">No</b-badge>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-sm-5">
                    <div>
                        <h7>Link</h7>
                        <h6 style="margin-top: 2px;">
                            <a :href="changemaker_view?.ngos?.link" target="_blank" rel="noopener noreferrer">
                                {{ changemaker_view?.ngos?.link.slice(0, 50) }}
                            </a>
                        </h6>
                    </div>
                </div>
                <div class="col-sm-7">
                    <div>
                        <h7>Address</h7>
                        <h6 style="margin-top: 2px;">{{ changemaker_view?.ngos?.address }}</h6>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-sm-12">
                    <div>
                        <h7>Bio</h7>
                        <div style="margin-top: 2px;" v-html="changemaker_view?.ngos?.ngo_bio"></div>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-sm-12">
                    <div>
                        <h7>Social Change Interests</h7>
                        <div style="display: flex; flex-wrap: wrap; gap: 4px;">
                            <div v-for="interest in changemaker_view?.ngos?.change_interest">
                                <b-badge variant="info">{{ interest }}</b-badge>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-sm-12">
                    <div>
                        <h7>Geographic Area of Operations</h7>
                        <div style="display: flex; flex-wrap: wrap; gap: 4px;">
                            <div v-for="interest in changemaker_view?.ngos?.geographic_area_of_operations">
                                <b-badge variant="info">{{ interest }}</b-badge>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-sm-12">
                    <div>
                        <h7>Interest in Joining</h7>
                        <div style="display: flex; flex-wrap: wrap; gap: 4px;">
                            <div v-for="interest in changemaker_view?.ngos?.interest_in_joining">
                                <b-badge variant="info">{{ interest }}</b-badge>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="changemaker_view?.category == 'gfc'">
            <div class="row">
                <div class="col-sm-4">
                    <div>
                        <h7>Education</h7>
                        <h6 style="margin-top: 2px;">{{ changemaker_view?.gfc?.education }}</h6>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div>
                        <h7>Profession</h7>
                        <h6 style="margin-top: 2px;">{{ changemaker_view?.gfc?.profession }}</h6>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div>
                        <h7>Occupation</h7>
                        <h6 style="margin-top: 2px;">{{ changemaker_view?.gfc?.occupation }}</h6>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-sm-4">
                    <div>
                        <h7>Gender</h7>
                        <h6 style="margin-top: 2px;">{{ changemaker_view?.gfc?.gender }}</h6>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div>
                        <h7>Date of Birth</h7>
                        <h6 style="margin-top: 2px;">{{ changemaker_view?.gfc?.birthdate }}</h6>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div>
                        <h7>Nationality</h7>
                        <h6 style="margin-top: 2px;">{{ changemaker_view?.gfc?.nationality }}</h6>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-sm-5">
                    <div>
                        <h7>State</h7>
                        <h6 style="margin-top: 2px;">{{ changemaker_view?.gfc?.state }}</h6>
                    </div>
                </div>
                <div class="col-sm-7">
                    <div>
                        <h7>City</h7>
                        <h6 style="margin-top: 2px;">{{ changemaker_view?.gfc?.city }}</h6>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="changemaker_view?.category == 'social'">
            <div class="row">
                <div class="col-sm-4">
                    <div>
                        <h7>Company</h7>
                        <h6 style="margin-top: 2px;">{{ changemaker_view?.social_enterprise?.company }}</h6>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div>
                        <h7>Contact Person</h7>
                        <h6 style="margin-top: 2px;">{{ changemaker_view?.social_enterprise?.contact_person_name }}</h6>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div>
                        <h7>Email</h7>
                        <h6 style="margin-top: 2px;">{{ changemaker_view?.social_enterprise?.email }}</h6>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-sm-4">
                    <div>
                        <h7>Phone Number</h7>
                        <h6 style="margin-top: 2px;">{{ changemaker_view?.social_enterprise?.phone_number }}</h6>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div>
                        <h7>Number of Employees</h7>
                        <h6 style="margin-top: 2px;">{{ changemaker_view?.social_enterprise?.number_of_employee }}</h6>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div>
                        <h7>Registered</h7>
                        <div style="margin-top: 2px;">
                            <b-badge v-if="changemaker_view?.social_enterprise?.registration == true" variant="success">Yes</b-badge>
                            <b-badge v-else variant="danger">No</b-badge>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-sm-5">
                    <div>
                        <h7>Link</h7>
                        <h6 style="margin-top: 2px;">
                            <a :href="changemaker_view?.social_enterprise?.link" target="_blank" rel="noopener noreferrer">
                                {{ changemaker_view?.social_enterprise?.link.slice(0, 50) }}
                            </a>
                        </h6>
                    </div>
                </div>
                <div class="col-sm-7">
                    <div>
                        <h7>Address</h7>
                        <h6 style="margin-top: 2px;">{{ changemaker_view?.social_enterprise?.address }}</h6>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-sm-12">
                    <div>
                        <h7>Bio</h7>
                        <div style="margin-top: 2px;" v-html="changemaker_view?.social_enterprise?.company_bio"></div>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-sm-12">
                    <div>
                        <h7>Social Change Interests</h7>
                        <div style="display: flex; flex-wrap: wrap; gap: 4px;">
                            <div v-for="interest in changemaker_view?.social_enterprise?.change_interest">
                                <b-badge variant="info">{{ interest }}</b-badge>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-sm-12">
                    <div>
                        <h7>Geographic Area of Operations</h7>
                        <div style="display: flex; flex-wrap: wrap; gap: 4px;">
                            <div v-for="interest in changemaker_view?.social_enterprise?.geographic_area_of_operations">
                                <b-badge variant="info">{{ interest }}</b-badge>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-sm-12">
                    <div>
                        <h7>Interest in Joining</h7>
                        <div style="display: flex; flex-wrap: wrap; gap: 4px;">
                            <div v-for="interest in changemaker_view?.social_enterprise?.interest_in_joining">
                                <b-badge variant="info">{{ interest }}</b-badge>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>

    <!-- Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this Changemaker?</div>
    </b-modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import {
    myHost
} from '../../_helpers/host'

export default {

    data() {
        return {
            host: myHost.host,
            tablefields: [
                {
                    key: 'index',
                    label: '#'
                },
                // {
                //     key: 'user',
                //     label: 'User',
                //     sortable: true
                // },
                {
                    key: 'name',
                    label: 'Name',
                    sortable: true
                },
                {
                    key: 'interest_in_joining',
                    label: 'Interest',
                    sortable: true
                },
                {
                    key: 'contact',
                    label: 'Contacts',
                    sortable: true
                },
                {
                    key: 'category',
                    label: 'Category',
                    sortable: true
                },
                {
                    key: 'verification_status',
                    label: 'Status',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: true
                }
            ],
            changemaker_view: null,
            filter: null,
            delete_value: null,

            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15]
        };
    },

    computed: {
        ...mapState({
            items: state => state.changemaker.changemakers,
            loading: state => state.changemaker.changemakerLoading,
            error: state => state.changemaker.changemakerError
        }),

        sortOptions() {
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
        }
    },

    watch: {

    },

    mounted() {
        this.$store.dispatch('changemaker/fetchChangemakerList').then(() => {
            this.totalRows = this.items.length;
        });
    },

    methods: {
        truncateText(text, maxLength) {
            if (text.length > maxLength) {
                return text.substring(0, maxLength) + '...';
            } else {
                return text;
            }
        },

        resetModal() {
            this.selectedStatus = '';
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        updateToggle(id) {
            this.$store.dispatch('changemaker/updateStatusToggle', {
                changemaker_id: id,
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: 'Success!',
                        text: response.response,
                        icon: 'success'
                    });
                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: response.response,
                        icon: 'error'
                    });
                }
            });
        },

        viewChangemaker(changemaker) {
            this.changemaker_view = changemaker
        },

        deleteChangemaker(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch('changemaker/deleteChangemaker', {
                delete_value: this.delete_value,
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: 'Success!',
                        text: response.response,
                        icon: 'success'
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: response.response,
                        icon: 'error'
                    });
                }
            });
        }
    }
};
</script>

<style scoped>
.header-mobile {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

@media screen and (max-width: 460px) {
    .header-mobile {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: start;
    }
}
</style>
